import { useState, useEffect, useContext } from 'react';
import Loader from "../../components/Loader";
import './style.css'
import API from '../../utils/API';
import Swal from 'sweetalert2';
import FileUploadContainer from '../../components/FileUploadContainer';
import SegmentedControl from '../../components/SegmentedControl';
import { useNavigate, useLocation } from 'react-router-dom';
import { AppContext } from "../../utils/ContextProvider";
import UtilityBillUploadHistory from '../UtilityBillUploadHistory';

const UtilityBillUpload = () => {

    const [accounts, setAccounts] = useState()
    const [tab, setTab] = useState(0)
    const [loading, setLoading] = useState(false)
    const context = useContext(AppContext);
    const location = useLocation();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(location.search);

    useEffect(() => {
        if (queryParams.size === 0 || queryParams.get('building') === "null") {
            navigate('/map')
        }
        if (context.getBuilding) return
        context.setBuilding(queryParams.get('building'))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [queryParams])

    useEffect(() => {
        if (!context.getBuildingInfo) return

        const cancelToken = API.cancelToken();
        setLoading(true)

        API.getUtilityAccountsByProprety(cancelToken, context.getBuildingInfo.property_id).then(res => {
            setAccounts(res.data)
            return
        }).catch(err => {
            console.log(err)
            if (err.message === 'cancelling') return
            let message = 'Please try again later.'
            if (err.response && err.response.data && err.response.data.includes('error')) {
                message = err.response.data.error
            }
            Swal.fire({
                title: 'Error.',
                text: message,
                icon: 'warning',
                confirmButtonText: 'Ok',
                confirmButtonColor: '#007b4e',
            });

        }).finally(f => {
            setLoading(false)
        })
        return () => {
            API.cancel(cancelToken);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [context.getBuildingInfo])

    return (
        <div className={`tablet:pl-12 tablet:pr-6`}>
            <div className='flex tablet:flex-nowrap mobile:flex-wrap justify-between items-center my-[40px]'>
                <h2 className="tablet:text-4xl mobile:text-xl font-bold text-[#332D41]">Utility Bill Upload</h2>
            </div>
            <SegmentedControl
                onChange={setTab}
                segments={['Upload Files', 'Manual Entry', 'Upload History']}
                defaultSelected={tab} />
            <div className='tablet:py-8 mobile:py-3 min-h-[80vh]'>
                {
                    loading &&
                    <Loader />
                }

                {
                    tab !== 2 && context.getUserInfo &&
                    (context.getUserInfo.manage_utility_bills ?
                        <FileUploadContainer accounts={accounts} method={tab} building={context.getBuilding} />
                        :
                        <p className='p-2'>You do not have access to this function.</p>)
                }
                {
                    tab === 2 &&
                    <UtilityBillUploadHistory building={context.getBuilding} />
                }

            </div>
        </div>
    );
};

export default UtilityBillUpload;